import axios from "../axios";


export const CountrySelectorApi = {
    get: async (json: any, currentCountry: string): Promise<any> => {
        try {
            return await axios.post("country/get", {currentCountry, ipResponse: json});
        } catch (e) {
            return Promise.reject(e);
        }
    }
};
